import { useQueryDocumentById } from '@/hooks/query/useQueryDocumentById';
import { TabType } from '@heidi/session/contracts';
import {
  useQuerySessionById,
  useSessionWindow,
  useSessionWindows,
} from '@heidi/session/data';

import { useIsFreeUser } from '@heidi/commerce/data';
import { useCurrentSessionId } from '@heidi/runtime/shell';
import { Brain } from '@heidi/schema/ml-scribe';
import { mapNewBrain } from '@heidi/session/data';

import { useMemo } from 'react';

export const useNoteOrDocumentInfo = (sessionId?: string | null) => {
  const currentSessionId = useCurrentSessionId();
  const effectiveSessionId = sessionId ?? currentSessionId;
  const { isFreeUser } = useIsFreeUser();

  const { activeWindowIndex } = useSessionWindows({
    sessionId: effectiveSessionId ?? '',
  });
  const { activeTab } = useSessionWindow({
    sessionId: effectiveSessionId ?? '',
    windowIndex: activeWindowIndex,
  });
  const tabName = activeTab?.name;
  const documentId = activeTab?.documentId ?? '';
  const { data: currentSession } = useQuerySessionById({
    sessionId: effectiveSessionId ?? '',
    select: (data) => {
      if (!data) return undefined;
      return {
        consult_note: data.consult_note,
        consult_note_result: data.consult_note.result,
      };
    },
  });
  const { data: currentDocument } = useQueryDocumentById({
    sessionId: effectiveSessionId ?? '',
    documentId,
    select: (data) => {
      if (!data) return undefined;
      return {
        brain: data.brain,
        content: data.content,
      };
    },
  });

  const brain = useMemo(() => {
    if (!effectiveSessionId) {
      return mapNewBrain(Brain.LEFT, isFreeUser);
    }
    return tabName !== TabType.DOCUMENT
      ? currentSession?.consult_note.brain
      : currentDocument?.brain;
  }, [
    effectiveSessionId,
    currentDocument?.brain,
    currentSession?.consult_note.brain,
    tabName,
    isFreeUser,
  ]);

  const content = useMemo(() => {
    if (!effectiveSessionId) {
      return '';
    }
    return tabName !== TabType.DOCUMENT
      ? currentSession?.consult_note_result || ''
      : currentDocument?.content || '';
  }, [
    effectiveSessionId,
    currentDocument?.content,
    currentSession?.consult_note_result,
    tabName,
  ]);

  return {
    brain: brain ?? mapNewBrain(Brain.LEFT, isFreeUser),
    content,
    tabName,
    documentId,
  };
};
